
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class UploadArea extends Vue {
  // @Prop({
  //   type: Number,
  //   required: true
  //   // default: 1
  // })
  // questionType!: number;
}
